import React, { useState } from 'react';
import {
    CardElement,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';
import * as styledComponents from './styles';
import axios from 'axios';

const CheckoutForm = ({ amount, showWaitingPayment, showSuccesfullPayment, showFailurePayment, products }) => {
    const [userEmail, setUserEmail] = useState('');
    const [userPhone, setUserPhone] = useState('');
    const [userName, setUserName] = useState('');

    const stripe = useStripe();
    const elements = useElements();
    const changeDetails = (e) => {
        console.log(e);
    }

    const onChangeEmail = (e) => {
        setUserEmail(e.target.value);
    }

    const onChangePhone = (e) => {
        setUserPhone(e.target.value);
    }

    const onChangeName = (e) => {
        setUserName(e.target.value);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        showWaitingPayment();
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
        });
        if (!error) {
            console.log("Stripe 23 | token generated!", paymentMethod);
            try {
                const { id } = paymentMethod;
                const response = await axios.post(
                    // "http://localhost:3000/payment/pay",
                    "https://oracliomapi.oracliom.com/payment/pay",
                    {
                        amount: amount * 100,
                        id: id,
                        userEmail: userEmail,
                        userPhone: userPhone,
                        userName: userName,
                        products: products,
                    }
                );
                console.log(response);
                console.log("Stripe 35 | data", response.data.success);
                if (response.data.success) {
                    showSuccesfullPayment();
                    console.log("CheckoutForm.js 25 | payment successful!");
                }
            } catch (error) {
                showFailurePayment();
                console.log("CheckoutForm.js 28 | ", error);
            }
        } else {
            console.log(error.message);
        }
    };

    return (
        <styledComponents.Form onSubmit={handleSubmit}>
            <styledComponents.Input placeholder={'Name'} onChange={onChangeName} value={userName} type="name" />
            <styledComponents.Input placeholder={'Email Address*'} onChange={onChangeEmail} value={userEmail} required type="email" />
            <styledComponents.Input placeholder={'Phone Number*'} onChange={onChangePhone} value={userPhone} required type="tel" />
            <CardElement
                onChange={changeDetails}
                options={{
                    style: {
                        base: {
                            fontSize: '16px',
                            fontFamily: 'Kula',
                            color: '#AAAAAA',
                            '::placeholder': {
                                color: '#AAAAAA',
                            },
                        },
                        invalid: {
                            color: '#FFFFFF',
                        },
                    },
                }}
            />
            <styledComponents.PayButton type="submit" disabled={!stripe}>
                PAY BY CARD: {amount} EUR
      </styledComponents.PayButton>
        </styledComponents.Form>
    );
};
export default CheckoutForm;